import { Container, Stack, Typography } from '@mui/material'
import Page                             from '../ui/components/Page'
import { useTranslation }               from 'react-i18next'
import Iconify                          from '../ui/components/Iconify'

export default function NotFoundPage() {
  const { t } = useTranslation()

  return <Page title={t('Not found')}>
    <Container>
      <Stack direction="column" spacing={2}>
          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <Iconify icon={'material-symbols:warning'} sx={{ height: 48, width: 48 }} />
            <Typography variant={'h4'}>{t('Not found')}</Typography>
          </Stack>
          <Typography variant={'caption'}>{t('Nothing here')}...</Typography>
      </Stack>
    </Container>
  </Page>
}